import React from 'react';
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Stack,
  Chip,
} from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory2Outlined';

/**
 * Single item card in the POS item grid.
 * Shows image (or placeholder), name, price, and stock indicator.
 * Clicking adds the item to the cart.
 */
export default function ItemCard({ item, onClick }) {
  const hasImage = item.item_image && !item.item_image.endsWith('/');
  const rate = item.price_list_rate || 0;
  const currency = item.currency || '';
  const inStock = item.actual_qty > 0;

  return (
    <Card variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardActionArea
        onClick={() => onClick(item)}
        sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
      >
        {hasImage ? (
          <CardMedia
            component="img"
            height="100"
            image={item.item_image}
            alt={item.item_name}
            sx={{ objectFit: 'contain', bgcolor: 'grey.50', p: 1 }}
          />
        ) : (
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{ height: 100, bgcolor: 'grey.50' }}
          >
            <InventoryIcon sx={{ fontSize: 40, color: 'grey.400' }} />
          </Stack>
        )}
        <CardContent sx={{ flexGrow: 1, py: 1, px: 1.5, '&:last-child': { pb: 1 } }}>
          <Typography variant="body2" fontWeight={600} noWrap title={item.item_name}>
            {item.item_name}
          </Typography>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 0.5 }}>
            <Typography variant="body2" color="primary" fontWeight={700}>
              {rate.toFixed(2)} {currency}
            </Typography>
            {item.is_stock_item ? (
              <Chip
                label={inStock ? item.actual_qty : 'Out'}
                size="small"
                color={inStock ? 'success' : 'error'}
                variant="outlined"
                sx={{ height: 20, fontSize: '0.7rem' }}
              />
            ) : null}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
